import { RedatedOrdersReport } from '@api/order-reporting/types/RedatedOrdersReport';
import { RedatedGridData } from '@pages/reporting-pages/redated-orders/types/RedatedGridData';
import { getParsedUnversionedSystemId } from '@utils/getParsedSystemId';
import { format, parseISO } from 'date-fns';
import { valueExist } from '@utils/typescriptGuards';
import { renderLitresToHL, numberWithSpaces } from 'components/global/utils';



export const convertToGridData = (apiData: RedatedOrdersReport[] | undefined | null): RedatedGridData[] | null => {
	if (!apiData) return null;

	let gridData: RedatedGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	

	gridData = apiData.map(x => ({
		...x,
		orderClientId: getParsedUnversionedSystemId(x.orderUnversionedSystemId).clientId,
		orderRequiredDeliveryDate: x.orderRequiredDeliveryDate ? format(parseISO(x.orderRequiredDeliveryDate), 'dd.MM.yyyy') : '-',
		orderRequiredDeliveryDateISO: x.orderRequiredDeliveryDate ? x.orderRequiredDeliveryDate : '-',
		orderOriginalRequiredDeliveryDate: x.orderOriginalRequiredDeliveryDate ? format(parseISO(x.orderOriginalRequiredDeliveryDate), 'dd.MM.yyyy') : '-',
		orderSentVolume: valueExist(x.orderSentVolume) ? renderLitresToHL(x.orderSentVolume, 2) : '0',
		orderSentCount: valueExist(x.orderSentCount) ? numberWithSpaces(x.orderSentCount) : '0',
	}));

	return gridData
}